module.exports = __webpack_public_path__ + "static/half-circle.69b2fb68.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/half-circle.png
// module id = 349
// module chunks = 35783957827783